import InventoZen from "@/components/icons/InventoZen.tsx";
import { Button } from "@/components/ui/button.tsx";
import React from "react";
import { useTranslation } from "react-i18next";

interface CheckEmailsProps {
  onNext: () => void;
  email: string;
}

const CheckEmails = ({ onNext, email }: CheckEmailsProps) => {
  const { t } = useTranslation();
  const resendEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    onNext();
  };

  return (
    <div className="h-full flex items-center justify-center">
      <div className="m-auto w-[500px] h-fit p-10 bg-white rounded-lg shadow border border-slate-200 flex-col justify-start items-center gap-8 inline-flex">
        <div>
          <div className="justify-center items-center flex">
            <InventoZen />
          </div>
          <p className="text-center text-slate-900 text-3xl font-semibold font-['Instrument Sans'] leading-loose">
            {t("checkYourEmails")}
          </p>
          <p className="text-center text-[#475467] text-base font-['Instrument Sans']">
            {t("weHaveSentAnEmailToThisAddress")} <strong>{email}</strong>
          </p>
        </div>
        <div className="w-full flex flex-col">
          <p className="text-center text-[#475467] text-base font-light font-['Instrument Sans']">
            {t("youHaveNotReceivedAnything")}
          </p>
          <Button
            type="submit"
            variant="ghost"
            onClick={resendEmail}
            className="mt-8 h-12 px-4 py-3 bg-[#008bd4] rounded-lg border border-[#006eab] justify-center items-center gap-1.5 inline-flex"
          >
            <div className="px-0.5 justify-center items-center flex">
              <p className="text-white text-base font-semibold font-['Raleway'] leading-normal">
                {t("resendEmail")}
              </p>
            </div>
          </Button>
          <a
            href="/"
            className="text-[#005d8d] text-sm font-semibold font-['Raleway'] text-center leading-normal mt-6"
          >
            {t("returnToLogin")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CheckEmails;
